const routes = {
  // COMMON
  HOME: "/home",
  LOGIN: "/prihlasenie",

  // COMPONENT WHICH REDIRECT USER BY URL PARAMS
  OAUTH_HANDLER: "/",

  // ZIS COMPONENTS
  FORGOT_PASSWORD: "/zabudnuteHeslo",
  INFO_USER: "/infoUser",
  REGISTRACIA: "/registracia",
  SPRAVY: "/spravy",
  PODAT_ZIADOST: "/podatZiadost",
  MOJE_ZIADOSTI: "/mojeZiadosti",
  VSETKY_ZIADOSTI: "/vsetkyZiadosti",
  MOJE_ULOHY: "/mojeUlohy",
  VYTVORIT_VYJADRENIE: "/vytvoritVyjadrenie",
  FAQ: "/faq",
};

export default routes;
